import _get from "lodash/get";
import React from 'react';
import classnames from 'classnames';
import { Button, ButtonType } from 'swag-client-common/components/ui/button';
import OutOfStockMessage from 'swag-client-common/components/ui/out-of-stock-message';
import classes from './samples-drawer.scss';
const SampleDrawerSizePicker = ({
  size,
  selectedIndex,
  outOfStockSizes,
  onSelectSize
}) => /*#__PURE__*/React.createElement("div", {
  className: classes.sizePicker
}, /*#__PURE__*/React.createElement("div", {
  className: classes.titleSize
}, "What size would you like?"), /*#__PURE__*/React.createElement("div", {
  className: classes.sizeSelectorsHolder
}, (_get(size, 'options') || []).map((sizeOption, index) => {
  const isSizeOutOfStock = outOfStockSizes[index];
  const isSizeActive = selectedIndex === index;
  return /*#__PURE__*/React.createElement("div", {
    key: sizeOption,
    className: classes.sizeSelectorWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    dataButton: sizeOption,
    type: ButtonType.primary,
    onClick: !isSizeOutOfStock ? onSelectSize(index) : undefined,
    className: classnames(classes.sizeButton, {
      [classes.active]: isSizeActive && !isSizeOutOfStock,
      [classes.disabled]: isSizeOutOfStock
    })
  }, /*#__PURE__*/React.createElement("div", {
    "data-size": sizeOption,
    "data-disable": isSizeOutOfStock
  }, sizeOption)), /*#__PURE__*/React.createElement(OutOfStockMessage, {
    twoLines: true,
    showCompletelyOutOfStockMessage: true,
    inStockQuantity: isSizeOutOfStock ? 0 : null
  }));
})));
export default SampleDrawerSizePicker;